<template>
  <div>
      <div ref="container" id="container"></div>
  </div>
</template>

<script>
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import pageLoadAnimationBus from '../pageLoadAnimationBus'
import homeOutAnimationBus from '../homeOutAnimationBus'
export default {
  name: 'THREE',
  data () {
    return {
      guides: false,
      mouse: {
        x: null,
        y: null
      },
      dimensions: {
        x: null,
        y: null
      },
      camera: null,
      scene: null,
      renderer: null,
      gltf: null,
      readVal: 0,
      target: new THREE.Vector3(),
      pos: 1,
      cameraAngleTarget: null,
      cameraZoomTarget: null,
      animating: true,
      fov: 1,
      fovAnimating: false,
      rotation: 1,
      Yrotation: 1.1,
      rotationAnimating: false,
      pan: 1,
      panAnimating: false
    }
  },
  computed: {
    // fov () { return this.$store.state.animations.globe.fov },
    // fovIsAnimating () { return this.$store.state.animations.globe.isAnimatingFov },
    // rotation () { return this.$store.state.animations.globe.rotation },
    // rotationIsAnimating () { return this.$store.state.animations.globe.isAnimatingRotation },
    // pan () { return this.$store.state.animations.globe.pan },
    // panIsAnimating () { return this.$store.state.animations.globe.isAnimatingPan }
  },
  methods: {
    init: function () {
      // Get mouse position and dimensions
      this.setVariables()
      // Create scene
      this.createScene()
      // Create camera
      this.createCamera()
      // Create lights
      this.createLights()
      // Create renderer
      this.createRenderer()
      // Load 3D model
      this.loadObject()
      // Create composer
      this.createComposer()

      // Handle window resize
      // window.addEventListener('resize', this.setDimensions, false)
      window.addEventListener('mousemove', this.setMouse)
    },
    setVariables: function () {
      this.dimensions = { x: window.innerWidth, y: window.innerHeight, halfX: (window.innerWidth / 2), halfY: (window.innerHeight / 2) }
    },
    createScene: function () {
      this.scene = new THREE.Scene()

      const color = 0xFFFFFF
      const near = -100
      const far = 250
      this.scene.fog = new THREE.Fog(color, near, far)

      // const color = 0xFFFFFF
      // const density = 0.6
      // this.scene.fog = new THREE.FogExp2(color, density)

      // Guides
      if (this.guides) {
        const size = 1
        const divisions = 100

        const gridHelper = new THREE.GridHelper(size, divisions)
        // gridHelper.rotateX(Math.PI / 32)
        gridHelper.rotateX(Math.PI / 2)

        const gridHelper2 = new THREE.GridHelper(size, divisions)
        // gridHelper2.rotateX(Math.PI / 2)

        const helperGroup = new THREE.Group()
        helperGroup.add(gridHelper)
        helperGroup.add(gridHelper2)

        this.scene.add(helperGroup)
      }
    },
    createCamera: function () {
      this.camera = new THREE.PerspectiveCamera((this.fov * 30) + 0.5, this.$refs.container.clientWidth / this.$refs.container.clientHeight, 0.1, 1500)
      // this.camera = new THREE.OrthographicCamera(this.$refs.container.clientWidth / -2, this.$refs.container.clientWidth / 2, this.$refs.container.clientHeight / 2, this.$refs.container.clientHeight / -2, 0.1, 2000)
      this.camera.position.z = 1
    },
    createLights: function () {
      this.light = new THREE.AmbientLight(0x404040, 0.2)
      this.scene.add(this.light)

      this.light2 = new THREE.DirectionalLight(0xFFFFFF, 1, 200)
      this.light2.position.set(-25, 25, 50)

      // light helper
      // const helper = new THREE.DirectionalLightHelper(this.light2, 5)
      // this.scene.add(helper)
      this.scene.add(this.light2)
    },
    createRenderer: function () {
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })

      this.$refs.container.appendChild(this.renderer.domElement)
    },
    createComposer: function () {
      // this.composer = new EffectComposer(this.renderer)
    },
    loadObject: function () {
      // instantiate a loader
      const loader = new GLTFLoader()

      // Load 3d model
      loader.load('planet.gltf', this.settings, undefined, function (error) {
        console.error(error)
      })
    },
    settings: function (gltf) {
      // Scene settings
      this.gltf = gltf.scene
      this.gltf.scale.set(this.dimensions.x / 1200000, this.dimensions.x / 1200000, this.dimensions.x / 1200000)
      this.gltf.rotation.set(1, this.Yrotation, this.rotation)

      // Add scene to a group so it can be rotated from it's current position
      this.wrapperGroup = new THREE.Group()
      this.wrapperGroup.add(this.gltf)

      // Add globe to scene
      this.scene.add(this.wrapperGroup)

      this.animate()
    },
    resizeRendererToDisplaySize: function () {
      const canvas = this.renderer.domElement
      const needResize = canvas.width !== window.innerWidth || canvas.height !== window.innerHeight

      if (needResize) {
        this.setVariables()
        this.renderer.setPixelRatio(window.devicePixelRatio)
        this.renderer.setSize(window.innerWidth / window.devicePixelRatio, window.innerHeight / window.devicePixelRatio, false)
        // Pan camera
        // this.camera.rotation.set(0, 0, 0)
        // const quaternion = new THREE.Quaternion()
        // const hFOV = 2 * Math.atan(Math.tan(this.camera.fov * Math.PI / 180 / 2) * this.camera.aspect) * 180 / Math.PI // degrees
        // var hFOVradians = THREE.MathUtils.degToRad(hFOV)
        // // console.log((hFOVradians / 4))
        // quaternion.setFromAxisAngle(new THREE.Vector3(0, 1, 0), (hFOVradians / 4))
        // this.camera.applyQuaternion(quaternion)
      }
      return needResize
    },
    setMouse: function (e) {
      this.mouse.x = (e.clientX - this.dimensions.halfX)
      this.mouse.y = (e.clientY - this.dimensions.halfY)
    },
    animate: function () {
      requestAnimationFrame(this.animate)

      const rendering = this.resizeRendererToDisplaySize()
      if (rendering) {
        this.camera.aspect = this.renderer.domElement.clientWidth / this.renderer.domElement.clientHeight
        this.camera.updateProjectionMatrix()
        if (this.gltf) {
          const scaleFactor = this.$vuetify.breakpoint.smAndDown ? 1200000 : 1200000
          const scaleValue = this.$vuetify.breakpoint.smAndDown ? ((this.renderer.domElement.clientWidth + 600) / scaleFactor) : this.renderer.domElement.clientWidth / scaleFactor
          this.gltf.scale.set(scaleValue, scaleValue, scaleValue)
        }
      }

      if (this.fovAnimating) {
        this.camera.fov = (this.fov * 30) + 0.5
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        const quat = new THREE.Quaternion()
        quat.setFromAxisAngle(new THREE.Vector3(0, 1, 0), 0.004)
        this.gltf.applyQuaternion(quat)
      } else if (this.rotationAnimating) {
        this.gltf.rotation.z = this.rotation
        this.gltf.rotation.y = this.Yrotation
      }

      // animate camera pan
      if (this.panAnimating || rendering) {
        this.camera.rotation.set(0, 0, 0)
        const quaternion = new THREE.Quaternion()
        const hFOV = 2 * Math.atan(Math.tan(this.camera.fov * Math.PI / 180 / 2) * this.camera.aspect) * 180 / Math.PI // degrees
        const hFOVradians = THREE.MathUtils.degToRad(hFOV)
        const placement = ((this.$vuetify.breakpoint.smAndDown) ? -(hFOVradians / 3) : (hFOVradians / 4)) * this.pan
        quaternion.setFromAxisAngle(new THREE.Vector3((this.$vuetify.breakpoint.smAndDown) ? 1 : 0, (this.$vuetify.breakpoint.smAndDown) ? 0 : 1, 0), placement)
        this.camera.applyQuaternion(quaternion)
      }
      this.target.x += ((this.mouse.x / 1000) - this.target.x) * 0.04
      this.target.y += (-(this.mouse.y / 1000) - this.target.y) * 0.04
      this.target.z = this.camera.position.z // assuming the camera is located at ( 0, 0, z );

      this.wrapperGroup.lookAt(this.target)

      this.camera.updateProjectionMatrix()

      this.renderer.render(this.scene, this.camera)
    }
  },
  mounted () {
    const interval = setInterval(() => {
      if (this.$refs.container) {
        this.init()
        pageLoadAnimationBus.registerComponent('globe', this)
        homeOutAnimationBus.registerComponent('globe', this)
        clearInterval(interval)
      }
    }, 50)
  }
}
</script>

<style scoped>
    /* //TODO give your container a size. */
    #container{
      width: 100vw;
      height: 100vh; /* Fallback for browsers that do not support Custom Properties */
      height: calc(var(--vh, 1vh) * 100);
      display: block;
      /* z-index: 100000000; */
      position: absolute;
    }
</style>
